<template>
  <div class="itemList">
    <div class="item" v-for="(item, index) in list" :key="index">
      <div :class="item.SubtractScore | statusFilter" class="dataLine status">
        <div class="date">
          <div class="month">{{ item.CreateTime | formatDay }}</div>
          <div class="year">{{ item.CreateTime | formatYear }}</div>
        </div>
      </div>
      <div class="con">
        <div class="ReasonTitle">
          {{ item.ViolationType | reasonTitleFilter }}
        </div>
        <div class="reasonDetail">
          <div class="subItem">
            <div class="label">{{ item.ViolationType | labelFilter1 }}</div>
            <div
              class="desc"
              v-text="item.AdminMessage ? item.AdminMessage : '暂无'"
            ></div>
          </div>
          <div class="subItem">
            <div class="label">{{ item.ViolationType | labelFilter2 }}</div>
            <div
              class="desc"
              v-text="item.PunishRemark ? item.PunishRemark : '暂无'"
            ></div>
          </div>
          <div class="subItem" v-show="item.IsSubtract">
            <div class="label">违规扣分：</div>
            <div class="desc">
              扣{{ item.SubtractScore ? item.SubtractScore : 0 }}分
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "recordList",
  data() {
    return {};
  },
  props: {
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  filters: {
    formatYear(val) {
      let tempYeear = moment(val).format("YYYY").toString();
      let currYear = moment().year().toString();
      let tempResult = "";
      if (currYear !== tempYeear) {
        tempResult = tempYeear + "年";
      }
      return tempResult;
    },
    formatDay(val) {
      return moment(val).format("MM-DD");
    },
    statusFilter(val) {
      let tempClass = "";
      if (val >= 7) {
        tempClass = "three";
      } else if (val > 3) {
        tempClass = "two";
      } else if (val > 0) {
        tempClass = "one";
      } else {
        tempClass = "four";
      }
      return tempClass;
    },
    reasonTitleFilter(val) {
      let tempStr = "";
      switch (val) {
        case 0:
          tempStr = "自行申请退款";
          break;
        case 1:
          tempStr = "退款不退还返利";
          break;
        case 2:
          tempStr = "关键词作弊";
          break;
        case 3:
          tempStr = "使用淘宝客";
          break;
        case 4:
          tempStr = "负面评价";
          break;
        case 5:
          tempStr = "违反平台规则";
          break;
        case 6:
          tempStr = "一人多号";
          break;
        case 7:
          tempStr = "联系商家提及违规话语";
          break;
        case 8:
          tempStr = "管理员临时限制";
          break;
        case 9:
          tempStr = "评价抄袭";
          break;
        case 10:
          tempStr = "平台风险控制";
          break;
        case 11:
          tempStr = "投诉商家";
          break;
        case 12:
          tempStr = "申请发票";
          break;
        case 13:
          tempStr = "使用其他红包优惠";
          break;
        case 14:
          tempStr = "使用保价服务";
          break;
        case 15:
          tempStr = "疫情地区下单";
          break;
        default:
          tempStr = "其他限制";
          break;
      }
      return tempStr;
    },
    labelFilter1(ViolationType) {
      let tempStr = "违规原因：";
      if (ViolationType === 8 || ViolationType === 10) {
        tempStr = "限制原因：";
      }
      return tempStr;
    },
    labelFilter2(ViolationType) {
      let tempStr = "限制处理：";
      if (ViolationType === 8 || ViolationType === 10) {
        tempStr = "违规处理：";
      }
      return tempStr;
    },
  },
};
</script>

<style lang="scss" scoped>
.itemList {
  position: relative;
  padding-right: 30px;
  .item {
    display: flex;
    // margin-bottom: 20px;
    &:first-child {
      padding-top: 10px;
    }
    &:last-child {
      margin-bottom: 0;
    }
    .dataLine {
      position: relative;
      display: flex;
      align-items: center;
      height: 20px;
      // margin-right: 10px;
      flex-shrink: 0;
      &.status::before {
        position: absolute;
        content: '';
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #0094ff;
        z-index: 100;
        right: 0;
        transform: translateX(50%);
      }
      &.status.one::before {
        background-color: #77bdf0;
      }
      &.status.two::before {
        background-color: #faac41;
      }
      &.status.three::before {
        background-color: #f22c2c;
      }
      &.status.four::before {
        background-color: #bbbbbb;
      }
      .date {
        position: relative;
        flex-shrink: 0;
        color: #8a8a8b;
        text-align: center;
        width: 70px;
        .month {
          height: 20px;
          line-height: 20px;
          font-size: 14px;
          text-align: center;
        }
        .year {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          font-size: 13px;
          text-align: center;
          width: auto;
          white-space:nowrap; 
        }
      }
    }
    .con {
      padding-left: 14px;
      border-left: 1px dashed rgb(228, 227, 227);
      padding-bottom: 20px;
      .ReasonTitle {
        height: 20px;
        line-height: 20px;
        font-size: 15px;
        font-weight: 700;
        margin-bottom: 10px;
      }
      .reasonDetail {
        font-size: 14px;
        .subItem {
          display: flex;
          margin-bottom: 10px;
          .label {
            flex-shrink: 0;
            line-height: 24px;
          }
          .desc {
            line-height: 24px;
          }
        }
      }
    }
  }
}
</style>
